import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import LatestNews from './components/LatestNews';
import CommentWaterfall from './components/CommentWaterfall';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '51吃瓜黑料网',
  url: 'http://moonr.cn/',
  description: '51吃瓜黑料网站🔥承接网曝门与在线爆料搜索需求，提供入口一二三、每日大赛及视频不打烊，⏰网红猛料实时追踪不停更。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://moonr.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title="51吃瓜黑料 | 51吃瓜黑料网 网曝门与爆料入口全收录 网红猛料不打烊实时更新"
        description="51吃瓜黑料网站🔥承接网曝门与在线爆料搜索需求，提供入口一二三、每日大赛及视频不打烊，⏰网红猛料实时追踪不停更。全网最新最全的娱乐八卦资讯平台。"
        keywords="51吃瓜黑料网, 51吃瓜黑料网曝门, 51吃瓜黑料入口, 51吃瓜黑料爆料, 51吃瓜黑料不打烊, 51吃瓜黑料在线, 吃瓜, 黑料, 每日大赛, 视频更新"
        ogTitle="51吃瓜黑料 | 51吃瓜黑料网 网曝门与爆料入口全收录"
        ogDescription="51吃瓜黑料网站🔥承接网曝门与在线爆料搜索需求，网红猛料实时追踪不停更。"
        ogImage="https://readdy.ai/api/search-image?query=Abstract%20modern%20entertainment%20news%20portal%20social%20share%20image%2C%20warm%20coral%20and%20amber%20gradient%20background%2C%20clean%20minimalist%20design%2C%20stylized%20speech%20bubbles%2C%20editorial%20aesthetic%2C%20no%20text%2C%20abstract%20visual&width=1200&height=630&seq=og-home-51chigua&orientation=landscape"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <LatestNews />
        <CommentWaterfall />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}